/***************/
/**  IMPORTS  **/
/***************/

/***********************/
/**  AMPLIFY IMPORTS  **/
/***********************/

/****************************/
/**  LOCAL/ASSETS IMPORTS  **/
/****************************/
import { AddressStatsProvider } from "../../../utils/LocationsContext";
import StreetBlockPDF from "../StreetBlockPDF";
import {
      Document,
      Page,
      Text,
      View,
      StyleSheet,
    } from "@react-pdf/renderer";

/******************/
/**  PDF STYLES  **/
/******************/
const styles = StyleSheet.create({
    page: {
        backgroundColor: "white",
        display: 'flex',
        width: "100%",
        flexDirection: "row",
        padding: 50,
    },
    header: {
        paddingTop: 15,
        flexDirection: "column",
        display: "flex",
        marginBottom: 20,
    },
    row: {
        flexDirection: "row",
        display: "flex",
    },
    col: {
        flexDirection: "col",
        display: "flex",
        height: "3px",
    },
    streetname: {
        fontSize: '11px',
        color: "red",
        fontFamily: "Helvetica-Bold",
        paddingBottom: '2px',
        flexDirection: 'row',
    },
    cross: {
        fontFamily: "Helvetica",
        fontSize: '8px',
        flexDirection: 'row',
    },
    horizontalstreet: {
        flexDirection: "row",
        display: "flex",
        width: "1px",
        justifyContent: "space-between",
        marginTop: "-3px",
    },
    horizontalstreetname: {
        display: "flex", 
        flexDirection: "column", 
        color: "#205DBC", 
        fontSize: "7px", 
        fontStyle: "bold", 
        marginLeft: "-370px",
        width: "90px",
        marginTop: "-3px",
    },
    });

    /**
     * This component is responsible for creating the PDF of the tenant map
     * @returns A tenant map
     */
    const GearyBlvdPDF = ({street, groupedAddresses, highlightAvailableIsChecked, highlightTempClosedIsChecked, addresses, highlightBuildingForSale, allTotalsAreChecked }) => {

        const between = {"2570": "PRESIDIO AVENUE", "3380": "COMMONWEALTH AVENUE", "3355": "BEAUMONT AVENUE", "3460": "JORDAN AVENUE", "3455": "STANYAN STREET", "3550": "PALM AVENUE"};
        const parks = {"2501": "Residential", "After 2700": "Residential", "Before 3233": "Residential", "Before 3921": "Residential", "Before 4099": "Residential", "Before 4228": "Residential", "4900": "Park Presidio Boulevard", "4901": "Park Presidio Boulevard", "Before 6333": "Residential"};

        if (!groupedAddresses) {
            console.log("Grouped Addresses");
            return <Text>Loading...</Text>; // Or any other loading indicator
        }

        let totalPg1 = 0;

        for (const key in groupedAddresses) {
        const numericKey = parseInt(key, 10);
            if (numericKey >= 2500 && numericKey <= 3200) {
                const { odds = [], evens = [] } = groupedAddresses[key];
                let largerGroupCount = Math.max(odds.length, evens.length);
                if (largerGroupCount < 3) {
                    largerGroupCount = 3;
                }
                totalPg1 += largerGroupCount;
            }
        }

        let totalPg2 = 0;

        for (const key in groupedAddresses) {
        const numericKey = parseInt(key, 10);
            if (numericKey >= 3300 && numericKey <= 4100) {
                const { odds = [], evens = [] } = groupedAddresses[key];
                let largerGroupCount = Math.max(odds.length, evens.length);
                if (largerGroupCount < 3) {
                    largerGroupCount = 3;
                }
                totalPg2 += largerGroupCount;
            }
        }

        let totalPg3 = 0;

        for (const key in groupedAddresses) {
        const numericKey = parseInt(key, 10);
            if (numericKey >= 4200 && numericKey <= 5000) {
                const { odds = [], evens = [] } = groupedAddresses[key];
                let largerGroupCount = Math.max(odds.length, evens.length);
                if (largerGroupCount < 3) {
                    largerGroupCount = 3;
                }
                totalPg3 += largerGroupCount;
            }
        }

        let totalPg4 = 0;

        for (const key in groupedAddresses) {
        const numericKey = parseInt(key, 10);
            if (numericKey >= 5100 && numericKey <= 5700) {
                const { odds = [], evens = [] } = groupedAddresses[key];
                let largerGroupCount = Math.max(odds.length, evens.length);
                if (largerGroupCount < 3) {
                    largerGroupCount = 3;
                }
                totalPg4 += largerGroupCount;
            }
        }

        let totalPg5 = 0;

        for (const key in groupedAddresses) {
        const numericKey = parseInt(key, 10);
            if (numericKey >= 5800 && numericKey <= 6300) {
                const { odds = [], evens = [] } = groupedAddresses[key];
                let largerGroupCount = Math.max(odds.length, evens.length);
                if (largerGroupCount < 3) {
                    largerGroupCount = 3;
                }
                totalPg5 += largerGroupCount;
            }
        }

        const allBlocksProps = {
            street: street, 
            between: between,
            parks: parks,
            highlightAvailableIsChecked,
            highlightTempClosedIsChecked
        };
        const pg1Props = {
            divisor: 8,
            maxTotalAddresses: totalPg1,
        };
        const pg2Props = {
            divisor: 9,
            maxTotalAddresses: totalPg2,
        };
        const pg3Props = {
            divisor: 9,
            maxTotalAddresses: totalPg3,
        };
        const pg4Props = {
            divisor: 7,
            maxTotalAddresses: totalPg4,
        };
        const pg5Props = {
            divisor: 6,
            maxTotalAddresses: totalPg5,
        };

        return (
            <Document>
                <Page size='A4' style={styles.page}>
                    <View style={styles.header}>
                        <Text style={{color: "#205DBC", fontSize: "12px", fontFamily: 'Times-Bold', width: "100px", display: "flex", flexDirection: "row", marginBottom: "12px"}}>
                            MAPRETAIL.NET
                        </Text>
                        <Text style={styles.streetname}>{street.toUpperCase()}</Text>
                        <Text style={styles.streetname}>TENANT MAP</Text>
                        <Text style={[styles.cross, {marginBottom: "15px"}]}>LYON TO 28TH</Text>
                        <AddressStatsProvider highlightAvailableIsChecked={highlightAvailableIsChecked} highlightTempClosedIsChecked={highlightTempClosedIsChecked} addresses={addresses} highlightBuildingForSale={highlightBuildingForSale} allTotalsAreChecked={allTotalsAreChecked} />
                        <View style={{flexDirection: 'row', display: 'flex'}}>
                            <Text style={{fontSize:"7px", marginTop: "370px", width: "100px"}}>Disclaimer:  All information on this Map is provided without guarantee and all information should be independently verified. There may be errors or omissions in the information presented, and the creators of this web application make no representations or warranties regarding its accuracy. It is the user's sole responsibility to conduct their own independent research and not to rely on this map application in any way. Furthermore, by agreeing to use this web application, you acknowledge and agree that it is prohibited to sell, reproduce, or utilize this map for any purpose other than personal, non-commercial use without the express written consent of the owners. We are not liable for any loss or damages arising from the use of this application, and users may be held liable for unauthorized use. For all inquiries, please contact: mapretail.net@gmail.com .</Text>
                        </View>
                    </View>
                    <View style={{flexDirection: 'column', display: 'flex', width: "300px", paddingLeft:"365px", justifyContent: "center"}}>
                        <View style={styles.horizontalstreet}>
                            <View style={styles.horizontalstreetname}>
                                <Text>LYON STREET</Text>
                            </View>
                            <View style={styles.col}>
                                <View style={{display: "flex", flexDirection: "row", height:'5px', backgroundColor: '#205DBC', width: "300px"}}></View>
                            </View>
                        </View>
                        <StreetBlockPDF 
                            {...allBlocksProps}
                            {...pg1Props}
                            addresses={groupedAddresses["2500"]} 
                            building={"2500"}/>
                        <StreetBlockPDF 
                            {...allBlocksProps}
                            {...pg1Props}
                            addresses={groupedAddresses["2600"]} 
                            building={"2600"}/>
                        <View style={styles.horizontalstreet}>
                            <View style={styles.horizontalstreetname}>
                                <Text>MASONIC AVENUE</Text>
                            </View>
                            <View style={styles.col}>
                                <View style={{display: "flex", flexDirection: "row", height:'5px', backgroundColor: '#205DBC', width: "300px"}}></View>
                            </View>
                        </View>
                        <StreetBlockPDF 
                            {...allBlocksProps}
                            {...pg1Props}
                            addresses={groupedAddresses["2700"]} 
                            building={"2700"}/>
                        <View style={styles.horizontalstreet}>
                            <View style={styles.horizontalstreetname}>
                                <Text>WOOD STREET</Text>
                            </View>
                            <View style={styles.col}>
                                <View style={{display: "flex", flexDirection: "row", height:'5px', backgroundColor: '#205DBC', width: "300px"}}></View>
                            </View>
                        </View>
                        <StreetBlockPDF 
                            {...allBlocksProps}
                            {...pg1Props}
                            addresses={groupedAddresses["2800"]} 
                            building={"2800"}/>
                        <View style={styles.horizontalstreet}>
                            <View style={styles.horizontalstreetname}>
                                <Text>COLLINS STREET</Text>
                            </View>
                            <View style={styles.col}>
                                <View style={{display: "flex", flexDirection: "row", height:'5px', backgroundColor: '#205DBC', width: "300px"}}></View>
                            </View>
                        </View>
                        <StreetBlockPDF 
                            {...allBlocksProps}
                            {...pg1Props}
                            addresses={groupedAddresses["2900"]} 
                            building={"2900"}/>
                        <View style={styles.horizontalstreet}>
                            <View style={styles.horizontalstreetname}>
                                <Text>BLAKE STREET</Text>
                            </View>
                            <View style={styles.col}>
                                <View style={{display: "flex", flexDirection: "row", height:'5px', backgroundColor: '#205DBC', width: "300px"}}></View>
                            </View>
                        </View>
                        <StreetBlockPDF 
                            {...allBlocksProps}
                            {...pg1Props}
                            addresses={groupedAddresses["3000"]} 
                            building={"3000"}/>
                        <View style={styles.horizontalstreet}>
                            <View style={styles.horizontalstreetname}>
                                <Text>COOK STREET</Text>
                            </View>
                            <View style={styles.col}>
                                <View style={{display: "flex", flexDirection: "row", height:'5px', backgroundColor: '#205DBC', width: "300px"}}></View>
                            </View>
                        </View>
                        <StreetBlockPDF 
                            {...allBlocksProps}
                            {...pg1Props}
                            addresses={groupedAddresses["3100"]} 
                            building={"3100"}/>
                        <View style={styles.horizontalstreet}>
                            <View style={styles.horizontalstreetname}>
                                <Text>SPRUCE STREET</Text>
                            </View>
                            <View style={styles.col}>
                                <View style={{display: "flex", flexDirection: "row", height:'5px', backgroundColor: '#205DBC', width: "300px"}}></View>
                            </View>
                        </View>
                        <StreetBlockPDF 
                            {...allBlocksProps}
                            {...pg1Props}
                            addresses={groupedAddresses["3200"]} 
                            building={"3200"}/>
                        <View style={styles.horizontalstreet}>
                            <View style={styles.horizontalstreetname}>
                                <Text>PARKER AVENUE</Text>
                            </View>
                            <View style={styles.col}>
                                <View style={{display: "flex", flexDirection: "row", display: "flex", flexDirection: "row", height:'5px', backgroundColor: '#205DBC', width: "300px"}}></View>
                            </View>
                        </View>
                    </View>
                </Page>
                <Page size='A4' style={styles.page}>
                    <View style={styles.header}>
                        <Text style={{color: "#205DBC", fontSize: "12px", fontFamily: 'Times-Bold', width: "100px", display: "flex", flexDirection: "row", marginBottom: "12px"}}>
                            MAPRETAIL.NET
                        </Text>
                        <Text style={styles.streetname}>{street.toUpperCase()}</Text>
                        <Text style={styles.streetname}>TENANT MAP</Text>
                        <Text style={styles.cross}>LYON TO 28TH</Text>
                        <View style={{flexDirection: 'row', display: 'flex'}}>
                            <Text style={{fontSize:"7px", marginTop: "420px", width: "100px"}}>Disclaimer:  All information on this Map is provided without guarantee and all information should be independently verified. There may be errors or omissions in the information presented, and the creators of this web application make no representations or warranties regarding its accuracy. It is the user's sole responsibility to conduct their own independent research and not to rely on this map application in any way. Furthermore, by agreeing to use this web application, you acknowledge and agree that it is prohibited to sell, reproduce, or utilize this map for any purpose other than personal, non-commercial use without the express written consent of the owners. We are not liable for any loss or damages arising from the use of this application, and users may be held liable for unauthorized use. For all inquiries, please contact: mapretail.net@gmail.com .</Text>
                        </View>
                    </View>
                    <View style={{flexDirection: 'column', display: 'flex', width: "300px", paddingLeft:"400px", justifyContent: "center"}}>
                        <View style={styles.horizontalstreet}>
                            <View style={styles.horizontalstreetname}>
                                <Text>PARKER AVENUE</Text>
                            </View>
                            <View style={styles.col}>
                                <View style={{display: "flex", flexDirection: "row", display: "flex", flexDirection: "row", height:'5px', backgroundColor: '#205DBC', width: "300px"}}></View>
                            </View>
                        </View>
                        <StreetBlockPDF 
                            {...allBlocksProps}
                            {...pg2Props}
                            addresses={groupedAddresses["3300"]} 
                            building={"3300"}/>
                        <StreetBlockPDF 
                            {...allBlocksProps}
                            {...pg2Props}
                            addresses={groupedAddresses["3400"]} 
                            building={"3400"}/>
                        <StreetBlockPDF 
                            {...allBlocksProps}
                            {...pg2Props}
                            addresses={groupedAddresses["3500"]} 
                            building={"3500"}/>
                        <StreetBlockPDF 
                            {...allBlocksProps}
                            {...pg2Props}
                            addresses={groupedAddresses["3600"]} 
                            building={"3600"}/>
                        <View style={styles.horizontalstreet}>
                            <View style={styles.horizontalstreetname}>
                                <Text>ARGUELLO BOULEVARD</Text>
                            </View>
                            <View style={styles.col}>
                                <View style={{display: "flex", flexDirection: "row", height:'5px', backgroundColor: '#205DBC', width: "300px"}}></View>
                            </View>
                        </View>
                        <StreetBlockPDF 
                            {...allBlocksProps}
                            {...pg2Props}
                            addresses={groupedAddresses["3700"]} 
                            building={"3700"}/>
                        <View style={styles.horizontalstreet}>
                            <View style={styles.horizontalstreetname}>
                                <Text>2ND AVENUE</Text>
                            </View>
                            <View style={styles.col}>
                                <View style={{display: "flex", flexDirection: "row", height:'5px', backgroundColor: '#205DBC', width: "300px"}}></View>
                            </View>
                        </View>
                        <StreetBlockPDF 
                            {...allBlocksProps}
                            {...pg2Props}
                            addresses={groupedAddresses["3800"]} 
                            building={"3800"}/>
                        <View style={styles.horizontalstreet}>
                            <View style={styles.horizontalstreetname}>
                                <Text>3RD AVENUE</Text>
                            </View>
                            <View style={styles.col}>
                                <View style={{display: "flex", flexDirection: "row", height:'5px', backgroundColor: '#205DBC', width: "300px"}}></View>
                            </View>
                        </View>
                        <StreetBlockPDF 
                            {...allBlocksProps}
                            {...pg2Props}
                            addresses={groupedAddresses["3900"]} 
                            building={"3900"}/>
                        <View style={styles.horizontalstreet}>
                            <View style={styles.horizontalstreetname}>
                                <Text>4TH AVENUE</Text>
                            </View>
                            <View style={styles.col}>
                                <View style={{display: "flex", flexDirection: "row", height:'5px', backgroundColor: '#205DBC', width: "300px"}}></View>
                            </View>
                        </View>
                        <StreetBlockPDF 
                            {...allBlocksProps}
                            {...pg2Props}
                            addresses={groupedAddresses["4000"]} 
                            building={"4000"}/>
                        <View style={styles.horizontalstreet}>
                            <View style={styles.horizontalstreetname}>
                                <Text>5TH AVENUE</Text>
                            </View>
                            <View style={styles.col}>
                                <View style={{display: "flex", flexDirection: "row", height:'5px', backgroundColor: '#205DBC', width: "300px"}}></View>
                            </View>
                        </View>
                        <StreetBlockPDF 
                            {...allBlocksProps}
                            {...pg2Props}
                            addresses={groupedAddresses["4100"]} 
                            building={"4100"}/>
                        <View style={styles.horizontalstreet}>
                            <View style={styles.horizontalstreetname}>
                                <Text>6TH AVENUE</Text>
                            </View>
                            <View style={styles.col}>
                                <View style={{display: "flex", flexDirection: "row", height:'5px', backgroundColor: '#205DBC', width: "300px"}}></View>
                            </View>
                        </View>
                    </View>
                </Page>
                <Page size='A4' style={styles.page}>
                    <View style={styles.header}>
                        <Text style={{color: "#205DBC", fontSize: "12px", fontFamily: 'Times-Bold', width: "100px", display: "flex", flexDirection: "row", marginBottom: "12px"}}>
                            MAPRETAIL.NET
                        </Text>
                        <Text style={styles.streetname}>{street.toUpperCase()}</Text>
                        <Text style={styles.streetname}>TENANT MAP</Text>
                        <Text style={styles.cross}>LYON TO 28TH</Text>
                        <View style={{flexDirection: 'row', display: 'flex'}}>
                            <Text style={{fontSize:"7px", marginTop: "420px", width: "100px"}}>Disclaimer:  All information on this Map is provided without guarantee and all information should be independently verified. There may be errors or omissions in the information presented, and the creators of this web application make no representations or warranties regarding its accuracy. It is the user's sole responsibility to conduct their own independent research and not to rely on this map application in any way. Furthermore, by agreeing to use this web application, you acknowledge and agree that it is prohibited to sell, reproduce, or utilize this map for any purpose other than personal, non-commercial use without the express written consent of the owners. We are not liable for any loss or damages arising from the use of this application, and users may be held liable for unauthorized use. For all inquiries, please contact: mapretail.net@gmail.com .</Text>
                        </View>
                    </View>
                    <View style={{flexDirection: 'column', display: 'flex', width: "300px", paddingLeft:"400px", justifyContent: "center"}}>
                        <View style={styles.horizontalstreet}>
                            <View style={styles.horizontalstreetname}>
                                <Text>6TH AVENUE</Text>
                            </View>
                            <View style={styles.col}>
                                <View style={{display: "flex", flexDirection: "row", height:'5px', backgroundColor: '#205DBC', width: "300px"}}></View>
                            </View>
                        </View>
                        <StreetBlockPDF 
                            {...allBlocksProps}
                            {...pg3Props}
                            addresses={groupedAddresses["4200"]} 
                            building={"4200"}/>
                        <View style={styles.horizontalstreet}>
                            <View style={styles.horizontalstreetname}>
                                <Text>7TH AVENUE</Text>
                            </View>
                            <View style={styles.col}>
                                <View style={{display: "flex", flexDirection: "row", height:'5px', backgroundColor: '#205DBC', width: "300px"}}></View>
                            </View>
                        </View>
                        <StreetBlockPDF 
                            {...allBlocksProps}
                            {...pg3Props}
                            addresses={groupedAddresses["4300"]} 
                            building={"4300"}/>
                        <View style={styles.horizontalstreet}>
                            <View style={styles.horizontalstreetname}>
                                <Text>8TH AVENUE</Text>
                            </View>
                            <View style={styles.col}>
                                <View style={{display: "flex", flexDirection: "row", height:'5px', backgroundColor: '#205DBC', width: "300px"}}></View>
                            </View>
                        </View>
                        <StreetBlockPDF 
                            {...allBlocksProps}
                            {...pg3Props}
                            addresses={groupedAddresses["4400"]} 
                            building={"4400"}/>
                        <View style={styles.horizontalstreet}>
                            <View style={styles.horizontalstreetname}>
                                <Text>9TH AVENUE</Text>
                            </View>
                            <View style={styles.col}>
                                <View style={{display: "flex", flexDirection: "row", height:'5px', backgroundColor: '#205DBC', width: "300px"}}></View>
                            </View>
                        </View>
                        <StreetBlockPDF 
                            {...allBlocksProps}
                            {...pg3Props}
                            addresses={groupedAddresses["4500"]} 
                            building={"4500"}/>
                        <View style={styles.horizontalstreet}>
                            <View style={styles.horizontalstreetname}>
                                <Text>10TH AVENUE</Text>
                            </View>
                            <View style={styles.col}>
                                <View style={{display: "flex", flexDirection: "row", height:'5px', backgroundColor: '#205DBC', width: "300px"}}></View>
                            </View>
                        </View>
                        <StreetBlockPDF
                            {...allBlocksProps}
                            {...pg3Props}
                            addresses={groupedAddresses["4600"]} 
                            building={"4600"}/>
                        <View style={styles.horizontalstreet}>
                            <View style={styles.horizontalstreetname}>
                                <Text>11TH AVENUE</Text>
                            </View>
                            <View style={styles.col}>
                                <View style={{display: "flex", flexDirection: "row", height:'5px', backgroundColor: '#205DBC', width: "300px"}}></View>
                            </View>
                        </View>
                        <StreetBlockPDF 
                            {...allBlocksProps}
                            {...pg3Props}
                            addresses={groupedAddresses["4700"]} 
                            building={"4700"}/>
                        <View style={styles.horizontalstreet}>
                            <View style={styles.horizontalstreetname}>
                                <Text>12TH AVENUE</Text>
                            </View>
                            <View style={styles.col}>
                                <View style={{display: "flex", flexDirection: "row", height:'5px', backgroundColor: '#205DBC', width: "300px"}}></View>
                            </View>
                        </View>
                        <StreetBlockPDF 
                            {...allBlocksProps}
                            {...pg3Props}
                            addresses={groupedAddresses["4800"]} 
                            building={"4800"}/>
                        <View style={styles.horizontalstreet}>
                            <View style={styles.horizontalstreetname}>
                                <Text>13TH AVENUE</Text>
                            </View>
                            <View style={styles.col}>
                                <View style={{display: "flex", flexDirection: "row", height:'5px', backgroundColor: '#205DBC', width: "300px"}}></View>
                            </View>
                        </View>
                        <StreetBlockPDF 
                            {...allBlocksProps}
                            {...pg3Props}
                            addresses={groupedAddresses["4900"]} 
                            building={"4900"}/>
                        <View style={styles.horizontalstreet}>
                            <View style={styles.horizontalstreetname}>
                                <Text>14TH AVENUE</Text>
                            </View>
                            <View style={styles.col}>
                                <View style={{display: "flex", flexDirection: "row", height:'5px', backgroundColor: '#205DBC', width: "300px"}}></View>
                            </View>
                        </View>
                        <StreetBlockPDF 
                            {...allBlocksProps}
                            {...pg3Props}
                            addresses={groupedAddresses["5000"]} 
                            building={"5000"}/>
                        <View style={styles.horizontalstreet}>
                            <View style={styles.horizontalstreetname}>
                                <Text>15TH AVENUE</Text>
                            </View>
                            <View style={styles.col}>
                                <View style={{display: "flex", flexDirection: "row", height:'5px', backgroundColor: '#205DBC', width: "300px"}}></View>
                            </View>
                        </View>
                    </View>
                </Page>
                <Page size='A4' style={styles.page}>
                    <View style={styles.header}>
                        <Text style={{color: "#205DBC", fontSize: "12px", fontFamily: 'Times-Bold', width: "100px", display: "flex", flexDirection: "row", marginBottom: "12px"}}>
                            MAPRETAIL.NET
                        </Text>
                        <Text style={styles.streetname}>{street.toUpperCase()}</Text>
                        <Text style={styles.streetname}>TENANT MAP</Text>
                        <Text style={styles.cross}>LYON TO 28TH</Text>
                        <View style={{flexDirection: 'row', display: 'flex'}}>
                            <Text style={{fontSize:"7px", marginTop: "420px", width: "100px"}}>Disclaimer:  All information on this Map is provided without guarantee and all information should be independently verified. There may be errors or omissions in the information presented, and the creators of this web application make no representations or warranties regarding its accuracy. It is the user's sole responsibility to conduct their own independent research and not to rely on this map application in any way. Furthermore, by agreeing to use this web application, you acknowledge and agree that it is prohibited to sell, reproduce, or utilize this map for any purpose other than personal, non-commercial use without the express written consent of the owners. We are not liable for any loss or damages arising from the use of this application, and users may be held liable for unauthorized use. For all inquiries, please contact: mapretail.net@gmail.com .</Text>
                        </View>
                    </View>
                    <View style={{flexDirection: 'column', display: 'flex', width: "300px", paddingLeft:"400px", justifyContent: "center"}}>
                        <View style={styles.horizontalstreet}>
                            <View style={styles.horizontalstreetname}>
                                <Text>15TH AVENUE</Text>
                            </View>
                            <View style={styles.col}>
                                <View style={{display: "flex", flexDirection: "row", height:'5px', backgroundColor: '#205DBC', width: "300px"}}></View>
                            </View>
                        </View>
                        <StreetBlockPDF 
                            {...allBlocksProps}
                            {...pg4Props}
                            addresses={groupedAddresses["5100"]} 
                            building={"5100"}/>
                        <View style={styles.horizontalstreet}>
                            <View style={styles.horizontalstreetname}>
                                <Text>16TH AVENUE</Text>
                            </View>
                            <View style={styles.col}>
                                <View style={{display: "flex", flexDirection: "row", height:'5px', backgroundColor: '#205DBC', width: "300px"}}></View>
                            </View>
                        </View>
                        <StreetBlockPDF 
                            {...allBlocksProps}
                            {...pg4Props}
                            addresses={groupedAddresses["5200"]} 
                            building={"5200"}/>
                        <View style={styles.horizontalstreet}>
                            <View style={styles.horizontalstreetname}>
                                <Text>17TH AVENUE</Text>
                            </View>
                            <View style={styles.col}>
                                <View style={{display: "flex", flexDirection: "row", height:'5px', backgroundColor: '#205DBC', width: "300px"}}></View>
                            </View>
                        </View>
                        <StreetBlockPDF 
                            {...allBlocksProps}
                            {...pg4Props}
                            addresses={groupedAddresses["5300"]} 
                            building={"5300"}/>
                        <View style={styles.horizontalstreet}>
                            <View style={styles.horizontalstreetname}>
                                <Text>18TH AVENUE</Text>
                            </View>
                            <View style={styles.col}>
                                <View style={{display: "flex", flexDirection: "row", display: "flex", flexDirection: "row", height:'5px', backgroundColor: '#205DBC', width: "300px"}}></View>
                            </View>
                        </View>
                        <StreetBlockPDF 
                            {...allBlocksProps}
                            {...pg4Props}
                            addresses={groupedAddresses["5400"]} 
                            building={"5400"}/>
                        <View style={styles.horizontalstreet}>
                            <View style={styles.horizontalstreetname}>
                                <Text>19TH AVENUE</Text>
                            </View>
                            <View style={styles.col}>
                                <View style={{display: "flex", flexDirection: "row", height:'5px', backgroundColor: '#205DBC', width: "300px"}}></View>
                            </View>
                        </View>
                        <StreetBlockPDF 
                            {...allBlocksProps}
                            {...pg4Props}
                            addresses={groupedAddresses["5500"]} 
                            building={"5500"}/>
                        <View style={styles.horizontalstreet}>
                            <View style={styles.horizontalstreetname}>
                                <Text>20TH AVENUE</Text>
                            </View>
                            <View style={styles.col}>
                                <View style={{display: "flex", flexDirection: "row", height:'5px', backgroundColor: '#205DBC', width: "300px"}}></View>
                            </View>
                        </View>
                        <StreetBlockPDF 
                            {...allBlocksProps}
                            {...pg4Props}
                            addresses={groupedAddresses["5600"]} 
                            building={"5600"}/>
                        <View style={styles.horizontalstreet}>
                            <View style={styles.horizontalstreetname}>
                                <Text>21ST AVENUE</Text>
                            </View>
                            <View style={styles.col}>
                                <View style={{display: "flex", flexDirection: "row", height:'5px', backgroundColor: '#205DBC', width: "300px"}}></View>
                            </View>
                        </View>
                        <StreetBlockPDF 
                            {...allBlocksProps}
                            {...pg4Props}
                            addresses={groupedAddresses["5700"]} 
                            building={"5700"}/>
                        <View style={styles.horizontalstreet}>
                            <View style={styles.horizontalstreetname}>
                                <Text>22ND AVENUE</Text>
                            </View>
                            <View style={styles.col}>
                                <View style={{display: "flex", flexDirection: "row", height:'5px', backgroundColor: '#205DBC', width: "300px"}}></View>
                            </View>
                        </View>
                    </View>
                </Page>
                <Page size='A4' style={styles.page}>
                    <View style={styles.header}>
                        <Text style={{color: "#205DBC", fontSize: "12px", fontFamily: 'Times-Bold', width: "100px", display: "flex", flexDirection: "row", marginBottom: "12px"}}>
                            MAPRETAIL.NET
                        </Text>
                        <Text style={styles.streetname}>{street.toUpperCase()}</Text>
                        <Text style={styles.streetname}>TENANT MAP</Text>
                        <Text style={styles.cross}>LYON TO 28TH</Text>
                        <View style={{flexDirection: 'row', display: 'flex'}}>
                            <Text style={{fontSize:"7px", marginTop: "420px", width: "100px"}}>Disclaimer:  All information on this Map is provided without guarantee and all information should be independently verified. There may be errors or omissions in the information presented, and the creators of this web application make no representations or warranties regarding its accuracy. It is the user's sole responsibility to conduct their own independent research and not to rely on this map application in any way. Furthermore, by agreeing to use this web application, you acknowledge and agree that it is prohibited to sell, reproduce, or utilize this map for any purpose other than personal, non-commercial use without the express written consent of the owners. We are not liable for any loss or damages arising from the use of this application, and users may be held liable for unauthorized use. For all inquiries, please contact: mapretail.net@gmail.com .</Text>
                        </View>
                    </View>
                    <View style={{flexDirection: 'column', display: 'flex', width: "300px", paddingLeft:"400px", justifyContent: "center"}}>
                        <View style={styles.horizontalstreet}>
                            <View style={styles.horizontalstreetname}>
                                <Text>22ND AVENUE</Text>
                            </View>
                            <View style={styles.col}>
                                <View style={{display: "flex", flexDirection: "row", height:'5px', backgroundColor: '#205DBC', width: "300px"}}></View>
                            </View>
                        </View>
                        <StreetBlockPDF 
                            {...allBlocksProps}
                            {...pg5Props}
                            addresses={groupedAddresses["5800"]} 
                            building={"5800"}/>
                        <View style={styles.horizontalstreet}>
                            <View style={styles.horizontalstreetname}>
                                <Text>23RD AVENUE</Text>
                            </View>
                            <View style={styles.col}>
                                <View style={{display: "flex", flexDirection: "row", height:'5px', backgroundColor: '#205DBC', width: "300px"}}></View>
                            </View>
                        </View>
                        <StreetBlockPDF 
                            {...allBlocksProps}
                            {...pg5Props}
                            addresses={groupedAddresses["5900"]} 
                            building={"5900"}/>
                        <View style={styles.horizontalstreet}>
                            <View style={styles.horizontalstreetname}>
                                <Text>24TH AVENUE</Text>
                            </View>
                            <View style={styles.col}>
                                <View style={{display: "flex", flexDirection: "row", height:'5px', backgroundColor: '#205DBC', width: "300px"}}></View>
                            </View>
                        </View>
                        <StreetBlockPDF 
                            {...allBlocksProps}
                            {...pg5Props}
                            addresses={groupedAddresses["6000"]} 
                            building={"6000"}/>
                        <View style={styles.horizontalstreet}>
                            <View style={styles.horizontalstreetname}>
                                <Text>25TH AVENUE</Text>
                            </View>
                            <View style={styles.col}>
                                <View style={{display: "flex", flexDirection: "row", height:'5px', backgroundColor: '#205DBC', width: "300px"}}></View>
                            </View>
                        </View>
                        <StreetBlockPDF 
                            {...allBlocksProps}
                            {...pg5Props}
                            addresses={groupedAddresses["6100"]} 
                            building={"6100"}/>
                        <View style={styles.horizontalstreet}>
                            <View style={styles.horizontalstreetname}>
                                <Text>26TH AVENUE</Text>
                            </View>
                            <View style={styles.col}>
                                <View style={{display: "flex", flexDirection: "row", height:'5px', backgroundColor: '#205DBC', width: "300px"}}></View>
                            </View>
                        </View>
                        <StreetBlockPDF 
                            {...allBlocksProps}
                            {...pg5Props}
                            addresses={groupedAddresses["6200"]} 
                            building={"6200"}/>
                        <View style={styles.horizontalstreet}>
                            <View style={styles.horizontalstreetname}>
                                <Text>27TH AVENUE</Text>
                            </View>
                            <View style={styles.col}>
                                <View style={{display: "flex", flexDirection: "row", height:'5px', backgroundColor: '#205DBC', width: "300px"}}></View>
                            </View>
                        </View>
                        <StreetBlockPDF 
                            {...allBlocksProps}
                            {...pg5Props}
                            addresses={groupedAddresses["6300"]} 
                            building={"6300"}/>
                        <View style={styles.horizontalstreet}>
                            <View style={styles.horizontalstreetname}>
                                <Text>28TH AVENUE</Text>
                            </View>
                            <View style={styles.col}>
                                <View style={{display: "flex", flexDirection: "row", display: "flex", flexDirection: "row", height:'5px', backgroundColor: '#205DBC', width: "300px"}}></View>
                            </View>
                        </View>
                    </View>
                </Page>
            </Document>
        )
        
    }

    export default GearyBlvdPDF;